import Counter from "./child/Counter"
import SumResult from "./child/SumResult"
import TableHead from "./child/TableHead"
import TableItem from "./child/TableItem"
import Btn from "./child/Btn"
import "./result.css"
import React from "react"

const Result = (props) => {
  const { result, counts, handleCountChange, removeItem } = props

  return (
    <div className="result">
      <TableHead />
      {result.length > 0 ? <SumResult result={result} counts={counts} /> : null}
      {result.map((item, index) => (
        <div className="result-list" key={index}>
          <TableItem item={item} count={counts[index] || "1"} />
          <Counter key={index} count={counts[index] || "1"} handleCountChange={(event) => handleCountChange(event, index)} />
          <Btn text="Remove item" onClick={() => removeItem(index)} />
          
        </div>
      ))}
    </div>
  )
}

export default Result
